import { wishlistsApi } from "@capone/common";
import { BoxProps } from "@material-ui/core";
import {
  ensureExhaustive,
  wishlistManagementModalActions,
  wishlistSnackbarActions,
  WishlistSnackbarType,
  WishlistToggleHeart as WishlistToggleHeartComponent,
} from "halifax";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FAVORITES_REMOVE_ITEM,
  FavoritesItemProperties,
  FavoritesItemType,
  ListingCollectionEnum,
} from "redmond";
import {
  LodgingCollectionEnum,
  StayType,
} from "redmond/hotels-module/interfaces";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";

export type WishlistHeartToggleProps = {
  listingId: string;
  stayType: StayType;
  collection?: ListingCollectionEnum | LodgingCollectionEnum;
  listingImageUrl?: string;
  style?: BoxProps;
};

export const WishlistToggleHeart = ({
  listingId,
  stayType,
  collection,
  listingImageUrl,
  style,
}: WishlistHeartToggleProps) => {
  const dispatch = useDispatch();

  const wishlistId = useSelector(
    wishlistsApi.endpoints.getAllWishlistItemsByUser.select()
  )?.data?.get(listingId);

  const onAddClick = () => {
    dispatch(
      wishlistManagementModalActions.openModal({
        listingId,
        listingImageUrl,
        stayType,
      })
    );
  };

  const itemType: FavoritesItemType = useMemo(() => {
    // switch on stayType and collection
    switch (stayType) {
      case StayType.Homes:
        return collection === ListingCollectionEnum.Lifestyle ||
          collection === LodgingCollectionEnum.Lifestyle
          ? "lifestyle_vr"
          : "premier_vr";
      case StayType.Hotels:
        return collection === ListingCollectionEnum.Lifestyle ||
          collection === LodgingCollectionEnum.Lifestyle
          ? "lifestyle_hotel"
          : "premier_hotel";
      default:
        return ensureExhaustive(stayType);
    }
  }, [stayType, collection]);

  const onRemoveClick = () => {
    trackEvent({
      eventName: FAVORITES_REMOVE_ITEM,
      properties: {
        item_id: listingId,
        item_type: itemType,
      } as FavoritesItemProperties,
    });
    dispatch(
      wishlistSnackbarActions.showSnackbar({
        type: WishlistSnackbarType.REMOVE,
        wishlistId,
        listingId,
        stayType,
      })
    );
  };

  return (
    <WishlistToggleHeartComponent
      isWishlisted={Boolean(wishlistId)}
      style={style}
      listingId={listingId}
      stayType={stayType}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
    />
  );
};
